/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type TruckInformationFragment = {
  __typename: 'Truck'
  id: number
  active: boolean
  showAsArchived: boolean
  preferredVendor: boolean
  name: string
  scheduleUrl: string
  menuUrl: string
  facebook: string | null
  instagram: string | null
  website: string | null
  twitter: string | null
  tiktok: string | null
  preferredVendorBadge: string | null
  instantBookEnabled: boolean
  description: { __typename: 'HtmlRecord'; html: string } | null
  foodImage: { __typename: 'TruckFoodImage'; medium: string } | null
  ratingInfo: {
    __typename: 'TruckRatingInfo'
    averageRating: number
    ratingsCount: number
    ratings: Array<{ __typename: 'PublicRating'; id: string }>
  } | null
  market: {
    __typename: 'Market'
    id: number
    customerPath: string
    name: string
    customerTrucksListPath: string
  }
  foodTypes: Array<{ __typename: 'FoodType'; id: number; name: string }>
}

export const TruckInformationFragment = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TruckInformationFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Truck' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showAsArchived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preferredVendor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'scheduleUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'menuUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tiktok' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preferredVendorBadge' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instantBookEnabled' }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foodImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ratingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageRating' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ratingsCount' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ratings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'market' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerPath' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerTrucksListPath' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foodTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
